export const SEARCH_RESULT_CLASSNAME = 'search-result';
export const SEARCH_RESULT_CONTEXT = 'search-result';

/** Prefix for all comment type search results */
export const COMMENT_MIMETYPE_PREFIX = 'comment-';
